import clsx from 'clsx'
import Link from 'next/link'
import { forwardRef, HTMLAttributes, ReactNode } from 'react'

import { IPortIcon, IPortIconMonochrome } from '@/shared/lib/icons'
import { Button } from '@/shared/ui'
import { Text } from '@/shared/ui'
import { Heading } from '@/shared/ui/heading'
import { Icon } from '@/shared/ui/icon'

import cl from './feature-card.module.scss'

const ArrowRight = () => <Icon name="ArrowRight" size={16} systemColor="iport" />

type FeatureCardAction = {
	actionLabel?: ReactNode
	actionHref?: string
	actionOnClick?: () => void
	actionElementClasses?: string[]
}

export interface FeatureCardProps extends HTMLAttributes<HTMLDivElement>, FeatureCardAction {
	variant?: 'vertical' | 'horizontal'
	icon?: IPortIcon | IPortIconMonochrome
	heading?: ReactNode
	text?: ReactNode
	customIcon?: ReactNode
}

export const FeatureCard = forwardRef<HTMLDivElement, FeatureCardProps>((props, ref) => {
	const {
		heading,
		text,
		icon,
		customIcon,
		variant = 'vertical',
		actionLabel = 'Узнать подробнее',
		actionHref,
		actionOnClick,
		actionElementClasses = [],
		className,
		...rest
	} = props

	const rootClasses = clsx(cl.root, className, cl[`variant-${variant}`])

	return (
		<div ref={ref} className={rootClasses} {...rest}>
			<div className={cl.main}>
				{(icon || customIcon) && (
					<div className={cl.icon}>{customIcon ? customIcon : icon && <Icon name={icon} size={40} />}</div>
				)}
				<div className={cl.content}>
					<Heading as="h3" preset="h4" className={cl.heading}>
						{heading}
					</Heading>
					<Text className={cl.text}>{text}</Text>
				</div>
			</div>
			{(actionHref || actionOnClick) && (
				<div className={cl.action}>
					{actionHref ? (
						<Link prefetch={false} href={actionHref} className={clsx(cl.link, ...actionElementClasses)}>
							{actionLabel} <ArrowRight />
						</Link>
					) : (
						<Button theme="link" className={clsx(cl.button, ...actionElementClasses)} onClick={actionOnClick}>
							{actionLabel} <ArrowRight />
						</Button>
					)}
				</div>
			)}
		</div>
	)
})
